import { render } from "./VehicleRequestProcess.vue?vue&type=template&id=39ef0000&scoped=true"
import script from "./VehicleRequestProcess.vue?vue&type=script&lang=js"
export * from "./VehicleRequestProcess.vue?vue&type=script&lang=js"

import "./VehicleRequestProcess.vue?vue&type=style&index=0&id=39ef0000&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ef0000"]])

export default __exports__